import { resetState } from './resetState';

export const actions = {
    resetState,
};
